import {Mapper} from '@s-ui/domain'

export default class HTTPRelatedAdsResponseJSONtoAdEntityMapper extends Mapper {
  constructor({adEntity, config}) {
    super()
    this._adEntity = adEntity
    this._config = config
  }

  map = ad => {
    const {photos, similarAdData, ...adData} = ad
    const [img] = photos

    return this._adEntity({
      img,
      ...similarAdData,
      ...adData,
      config: this._config
    })
  }
}
